module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0009.jpg?v=7a74918f";